import { Button, Col, Container, Row } from "react-bootstrap"
import VrboWebhooksManager from "../../../Components/VRBOIntegration/VrboWebhooksManager"
import { navigateTo } from "../../../redux/router/routerActions"
import { useAppDispatch } from "../../../redux/store"
import VrboMetadataSection from "../../../Components/VRBOIntegration/sections/VrboMetadataSection"

export default function VrboIntegrationsPage() {

    const dispatch = useAppDispatch()

    return (
        <Container>
            <Row>
                <Col>
                    <div className="d-flex justify-content-between align-items-center">
                        <h1>VRBO Integration</h1>
                        <Button
                            variant="outline-secondary"
                            onClick={() => dispatch(navigateTo('/platform-integrations'))}
                        >
                            Back to Platform Integrations
                        </Button>
                    </div>
                    <hr />
                    <h2>Tools</h2>
                    <Button
                        variant="outline-primary"
                        className="mb-3"
                        onClick={() => dispatch(navigateTo('/integrations/vrbo-mapper'))}
                    >
                        VRBO Mapper
                    </Button>
                    <h2>Webhooks</h2>
                    <VrboWebhooksManager />
                    <VrboMetadataSection /> 
                </Col>
            </Row>
        </Container>
    )
}
